import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
  idsProjeto?: number[];
  idsCentroCusto?: number[];
  idsSolicitante?: number[];
  status?: number;
  statusEmail?: number;
  dataDe?: Date | null;
  dataAte?: Date | null;
};

type Actions = {
  setIdsProjeto: (value: number[]) => void;
  setIdsCentroCusto: (value: number[]) => void;
  setIdsSolicitante: (value: number[]) => void;
  setStatus: (value: number) => void;
  setStatusEmail: (value: number) => void;
  // setEmailEnviado: (value: string) => void;
  setPeriodo: (de: Date | null, ate: Date | null) => void;
  clear: () => void;
};

export const useProjetoImpressaoFilters = create<State & Actions>((set) => ({
  idsProjeto: [],
  idsCentroCusto: [],
  idsSolicitante: [],
  status: 3,
  statusEmail: 2,
  // emailEnviado: undefined,
  dataDe: null,
  dataAte: null,

  setIdsProjeto: (value) => set({ idsProjeto: value }),
  setIdsCentroCusto: (value) => set({ idsCentroCusto: value }),
  setIdsSolicitante: (value) => set({ idsSolicitante: value }),
  setStatus: (value) => set({ status: value }),
  setStatusEmail: (value) => set({ statusEmail: value }),
  setPeriodo: (de, ate) => set({ dataDe: de, dataAte: ate }),

  clear: () =>
    set({
      idsProjeto: [],
      idsCentroCusto: [],
      idsSolicitante: [],
      status: 3,
      statusEmail: 2,
      dataDe: null,
      dataAte: null,
    }),
}));
